/** @jsxImportSource theme-ui @jsxRuntime classic */
import {
  AnchorSection,
  Box,
  Container,
  IntrinsicImage,
  Link,
  Text,
  useBreakpointIndex,
} from '@tishman/components';
import { IGatsbyImageData } from 'gatsby-plugin-image';
import React from 'react';

interface LoungeProps {
  alt: string;
  image: IGatsbyImageData;
  id?: string;
  subtitle: string;
  title: string;
}

const TheLoungeAtRockefellerCenter = ({
  alt,
  image,
  id = 'the-lounge',
  subtitle,
  title,
}: LoungeProps): React.JSX.Element => {
  const isMobile = useBreakpointIndex() < 2;

  return (
    <AnchorSection
      bg="primary"
      id={id}
      paddingBottom={[4, null, 8]}
      paddingTop={[0, null, 6]}
    >
      {/* LOUNGE IMAGE MOBILE */}
      {isMobile && (
        <Box pb={4}>
          <IntrinsicImage alt={alt} image={image} sx={{ maxHeight: 500 }} />
        </Box>
      )}
      <Container>
        {/* LOUNGE TITLE */}
        <Text
          sx={{
            color: 'black',
            fontSize: [5, null, 7],
            fontWeight: 'medium',
            lineHeight: ['34px', '52px'],
            variant: 'heading',
          }}
        >
          {title}
        </Text>
        {/* LOUNGE SUBTITLE */}
        <Text
          sx={{
            color: 'black',
            fontSize: 2,
            pb: [3, null, 6],
            pt: 3,
          }}
          variant="mediumP"
        >
          {subtitle}
        </Text>
        {/* MOBILE ONLY BUTTON */}
        <Box sx={{ display: ['flex', null, 'none'] }}>
          <Link
            sx={{
              bg: 'black',
              color: 'white',
              flexGrow: 1,
              textAlign: 'center',
            }}
            to="/buy-tickets"
            variant="buttonInverted"
          >
            Buy Tickets
          </Link>
        </Box>
        {/* LOUNGE IMAGE DESKTOP */}
        {!isMobile && (
          <Box sx={{ mx: 'auto' }}>
            <IntrinsicImage
              alt={alt}
              image={image}
              sx={{ maxHeight: 388, maxWidth: 1200, mx: 'auto' }}
            />
          </Box>
        )}
      </Container>
    </AnchorSection>
  );
};

export default TheLoungeAtRockefellerCenter;
